import { isDev } from "./isDev.js";
function printTidalVersions() {
  const __DEV__ = isDev();
  try {
    if (__DEV__ && window.tidal?.packages) {
      console.groupCollapsed(`[tidal] Registered Packages`);
      console.table(window.tidal.packages);
      console.groupEnd();
    } else {
    }
  } catch (_e) {
  }
}
export {
  printTidalVersions
};
//# sourceMappingURL=printTidalVersions.js.map
